/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 510 510" {...props}>
    <g fillRule="nonzero" fill="none">
      <circle
        cx={240}
        cy={240}
        r={240}
        fill="#FFF"
        stroke="currentColor"
        strokeWidth={30}
        transform="translate(15 15)"
      />
      <path
        d="M221.215 342.863c-4.429 0-8.028-1.665-10.796-4.995l-56.056-64.934c-2.491-3.33-3.598-6.869-3.321-10.615.276-3.746 1.937-7.007 4.982-9.782 3.045-2.775 6.505-3.954 10.381-3.538 3.875.417 7.197 2.151 9.965 5.203l44.845 52.031 112.112-133.198c2.491-3.053 5.675-4.718 9.55-4.995 3.876-.278 7.336.901 10.38 3.538 3.046 2.636 4.776 5.827 5.191 9.573.415 3.747-.761 7.285-3.53 10.615L232.012 337.868c-2.768 3.33-6.367 4.995-10.796 4.995z"
        fill="currentColor"
      />
    </g>
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconCircleCheck = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconCircleCheck.defaultProps = {
  theme,
};
IconCircleCheck.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconCircleCheck.displayName = 'IconCircleCheck';
export { IconCircleCheck };
